export const clickStreamEventName = {
    DELETE_USER:'delete_user',
    CART_VIEW: 'CART_VIEW',
    VARIANT_ITEM: "VARIANT_ITEM",
    BANK_DISCOUNT_BANNER: "BANK_DISCOUNT_BANNER",
    BANNERS_03: "BANNERS_03",
    PRODUCT_OF_THE_DAY: "PRODUCT_OF_THE_DAY",
    SEE_ALL_PRODUCTS: "SEE_ALL_PRODUCTS",
    KNOW_MORE: "KNOW_MORE",
    CATEGORY_CLICK:"CATEGORY_CLICK",
    CONFUSED_ABOUT:"CONFUSED_ABOUT_YOUR_HAIR_STAGE",
    PRODUCT_BENEFITS:"PRODUCT_BENEFITS",
    MONTH_WISE_RESULT:"MONTH_WISE_RESULT",
    MONTH_WISE_RESULT_SLIDER:"MONTH_WISE_RESULT_SLIDER",
    MENU: "MENU",
    KNOW_YOUR_STAGE:"KNOW_YOUR_STAGE",
    PAYMENT_FAILURE_POPUP_COD: "PAYMENT_FAILURE_POPUP_COD",
    PAYMENT_FAILURE_POPUP_RETRY: "PAYMENT_FAILURE_POPUP_RETRY",
    PRODUCT_PAGE_SCROLL: "PRODUCT_PAGE_SCROLL",
    PRODUCT_IMAGE_VIEWED: "PRODUCT_IMAGE_VIEWED",
    PRODUCT_REVIEW_READ: "PRODUCT_REVIEW_READ",
    PRODUCT_ABOUT_TAB_CLICK: "PRODUCT_ABOUT_TAB_CLICK",
    PRODUCT_VIEW_OFFER: "PRODUCT_VIEW_OFFER",
    PRODUCT_NOTIFY_ME: "PRODUCT_NOTIFY_ME",
    PRODUCT_WISHLIST: "PRODUCT_WISHLIST",
    CATEGORY_PAGE_SCROLL: "CATEGORY_PAGE_SCROLL",
    SCREEN_VIEW: "PAGE_LOAD",
    PDP_Know_click: "PDP_Know_click",
    PDP_Retail_click: "PDP_Retail_click",
    Retail_store_poPup_callClick: "callClick",
    Retail_store_poPup_directionClick: "directionClick",
    Know_more_load: "Know_more_load",
    know_more_Find_nearest_store: "know_more_Find_nearest_store",
    PDP_compare_click: "PDP_compare_click",
    Compare_search: "Compare_search",
    Compare_now: "Compare_now",
    Compare_clear: "Compare_clear",
    Compare_result_buy: "Compare_result_buy",
    PAYMENT_RETRY_AUTOLOGIN: "PAYMENT_RETRY_AUTOLOGIN",
    PAYMENT_RETRY_POP_VIEWED: 'PAYMENT_RETRY_POP_VIEWED',
    APPLY_FILTER: "APPLY_FILTER",
    RESET_FILTER: "RESET_FILTER",
    APPLY_SORT: "APPLY_SORT",
    PLP_COMPARE_CLICK: "PLP_compare_click",
    PLP_KNOW_CLICK: "PLP_Know_click",
    // TrueBasics New Events
    HOME_BANNER_CLICK: "HOME_BANNER_CLICK",
    HOME_MENU_CLICK: "HOME_MENU_CLICK",
    HOME_CATEGORY_CLICK: "HOME_CATEGORY_CLICK",
    HOME_SEE_DIFF_CLICK: "HOME_SEE_DIFF_CLICK",
    HOME_SEE_PROMISE_CLICK: "HOME_SEE_PROMISE_CLICK",
    HOME_BANNER_VIEW: "HOME_BANNER_VIEW",
    HOME_WHY_TBS_SECTION_VIEW: "HOME_WHY_TBS_SECTION_VIEW",
    HOME_QUALITY_SECTION_VIEW: "HOME_QUALITY_SECTION_VIEW",
    HOME_HONESTY_SECTION_VIEW: "HOME_HONESTY_SECTION_VIEW",
    HOME_STORIES_SECTION_VIEW: "HOME_STORIES_SECTION_VIEW",
    HOME_INSTAFEEDS_SECTION_VIEW: "HOME_INSTAFEEDS_SECTION_VIEW",
    HOME_NUT_SUPP_VIEW: "HOME_NUT_SUPP_VIEW",
    HOME_SEO_SECTION_VIEW: "HOME_SEO_SECTION_VIEW",
    //Category Page
    CATEGORY_SECTION_VIEW: "CATEGORY_SECTION_VIEW",
    //PDP Page
    PDP_BANNER_VIEW: "PDP_BANNER_VIEW",
    PDP_COMPOSITION_SECTION_VIEW: "PDP_COMPOSITION_SECTION_VIEW",
    PDP_CONSTITUENTS_SECTION_VIEW: "PDP_CONSTITUENTS_SECTION_VIEW",
    PDP_SECTION_VIEW: "PDP_SECTION_VIEW",
    PDP_PRODUCT_ICON_CLICK: "PDP_PRODUCT_ICON_CLICK",
    PDP_PRODUCT_LAYER_ICON_CLICK: "PDP_PRODUCT_LAYER_ICON_CLICK",
    PDP_PRODUCT_LAYER_IMAGES_CLICK: "PDP_PRODUCT_LAYER_IMAGES_CLICK",
    PDP_MWEB_PRODUCT_IMAGE_VIEWED: "PDP_MWEB_PRODUCT_IMAGE_VIEWED",
    PDP_MWEB_PRODUCT_IMAGE_VIEWED_POPUP: "PDP_MWEB_PRODUCT_IMAGE_VIEWED_POPUP",
    // HOME Sections Click Events
    HOME_ALL_STORIES_CTA: 'HOME_ALL_STORIES_CTA',
    HOME_EXPLORE_CTA: 'HOME_EXPLORE_CTA',
    FOOTER_SUBSCRIBE_CTA: 'FOOTER_SUBSCRIBE_CTA',
    INSTAGRAM_IMAGE_CLICK: 'INSTAGRAM_IMAGE_CLICK',
    FOOTER_REFER_AND_EARN_CTA: 'FOOTER_REFER_AND_EARN_CTA',
    FOOTER_INGREDIENTS_CTA: 'FOOTER_INGREDIENTS_CTA',
    ADD_TO_CART_DESKTOP_CTA: 'ADD_TO_CART_DESKTOP_CTA',
    GO_TO_CART_DESKTOP_CTA: 'GO_TO_CART_DESKTOP_CTA',
    ADD_TO_CART_MWEB_CTA: 'ADD_TO_CART_MWEB_CTA',
    ADD_MWEB_CTA: 'ADD_MWEB_CTA',
    VIEW_NUT_INFO: 'VIEW_SUPPLIMENT_FACTS',
    PDP_READ_MORE: 'PDP_READ_MORE',
    PDP_FAQ_EVENT: 'PDP_FAQ_EVENT',
    PDP_WHY_PRODUCT: 'PDP_WHY_PRODUCT',
    PDP_ADD_REVIEW: 'PDP_ADD_REVIEW',
    PDP_VIEW_ALL_REVIEW: 'PDP_VIEW_ALL_REVIEW',
    CART_CHECKOUT_CLICK: 'CART_CHECKOUT_CLICK',
    CART_CONTINUE_SHOPPING_CLICK: 'CART_CONTINUE_SHOPPING_CLICK',
    CART_LOGIN_CLICK: 'CART_LOGIN_CLICK',
    PAYMENT_MODE: 'PAYMENT_MODE',
    PAY_SECURE_CLICK: 'PAY_SECURE_CLICK',
    CHANGE_ADDR_PAYMENT: 'CHANGE_ADDR_PAYMENT',
    INGREDIENT_TILE: 'INGREDIENT_TILE',
    FILTER_APPLIED: 'FILTER_APPLIED',
    SEARCH_CONTENT: 'SEARCH_CONTENT',
    SEARCH_CLICKED: 'SEARCH_CLICKED',
    ACCORDIAN_RESEARCH_LINK_CLICKED: 'ACCORDIAN_RESEARCH_LINK_CLICKED',
    ACCORDIAN_CLICK: 'ACCORDIAN_CLICK',
    RESEARCH_LINK_CLICKED: 'RESEARCH_LINK_CLICKED',
    PLP_PRODUCT_CLICK: 'PLP_PRODUCT_CLICK',
    LOGIN_COUPON: 'LOGIN_COUPON',
    AUTH_BUTTON_CLICKED_MOB: 'AUTHENTICATE_PRODUCT_CLICKED_MOBILE',
    AUTH_BUTTON_CLICKED_FOOTER: 'AUTH_BUTTON_CLICKED_FOOTER',
    AUTH_BUTTON_CLICKED_IOS: 'AUTH_BUTTON_CLICKED_IOS',
    AUTH_CODE_SCANNED: 'AUTH_CODE_SCANNED',
    FLAVOUR_LAYER_PDP: "FLAVOUR_LAYER_PDP",
    BANNER_VIEW: 'BANNER_VIEW',
    WIDGET_ITEM_VIEW: 'WIDGET_ITEM_VIEW',
    APPLY_SORT_CLICK: 'APPLY_SORT_CLICK',
    SEARCH_ICON: 'SEARCH_ICON',
    SEARCH_TEXT_BAR: 'SEARCH_TEXT_BAR',
    PAGE_LOAD: 'PAGE_LOAD',
    COMPONENT_CLICK: 'COMPONENT_CLICK',
    COMPONENT_VIEW: 'COMPONENT_VIEW',
    ERROR: 'ERROR',
    HKVCODE: 'HKV_CODE_BANNER_CLICK',
};